// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O0qH","toggle":"styles_toggle__3XHDr","preview":"styles_preview__2GMfO"};